export const TYPOGRAPHY_CLASS =
  'qc-editable-typography-launcher';
export const POPOVER_CLASS =
  'qc-editable-typography-popover';
